import * as constants from "./constants";
import { message } from 'antd';
import electricApi from "@/api/electric";


export const changeElectric = (data, type) => {
    return {
        type: type,
        data
    };
};
//数据补招
export const electricMake = (data) => {
    return (dispatch) => {
        electricApi.getElectricMake(data)
            .then(res => {
                console.log(res)
                if(res?.code === 200) {
                    message.success('召测成功');
                } else {
                    message.error((res && res.msg) || '网络错误');
                }
            })
    };
};
//数据列表
export const getElectricList = (data) => {
    return (dispatch) => {
        electricApi.getElectricFreezeList(data)
            .then(res => {
                if(res) {
                    dispatch(changeElectric(res, constants.ELECTRIC_DATA));
                }
            })
    };
};

//历史曲线补招
export const getElectricHistory = (data) => {
    return (dispatch) => {
        electricApi.getElectricHistory(data)
            .then(res => {
                if(res?.code === 200) {
                    message.success('召测成功');
                } else {
                    message.error((res && res.msg) || '网络错误');
                }
            })
    };
};
//历史曲线列表
export const getElectricHistoryList = (data) => {
    return (dispatch) => {
        electricApi.getElectricHistoryList(data)
            .then(res => {
                if(res) {
                    dispatch(changeElectric(res, constants.ELECTRIC_HISTORY));
                }
            })
    };
};

//需量数据
export const getElectricDemandList = (data) => {
    return (dispatch) => {
        electricApi.getElectricDemandList(data)
            .then(res => {
                if(res) {
                    dispatch(changeElectric(res, constants.ELECTRIC_DEMAND));
                }
            })
    };
};
